
import UpdateDepartmentForm from 'components/form/super-admin/master/department/UpdateDepartmentForm'
import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'


export default class UpdateDepartment extends Component {
    render() {
        return (
            <>
                <div className="page-content">
                    <Container fluid>
                        <Row>
                            <Col xl='12'>
                                <h4 className="mb-0 font-size-18"> Update Department</h4>
                               <UpdateDepartmentForm/>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
